import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SavedTab = "task" | "tip";

interface StoredActiveSavedTab {
  activeTab: SavedTab;
}

interface SavedRecommendationTabState {
  activeTab: SavedTab;
}

const initialState: SavedRecommendationTabState = {
  activeTab: "task",
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setSavedTab(state, action: PayloadAction<StoredActiveSavedTab>) {
      const { activeTab } = action.payload;

      state.activeTab = activeTab;
    },
  },
});

export const { setSavedTab } = dashboardSlice.actions;

export const dashboardSliceReducer = dashboardSlice.reducer;
